const date = new Date();

export const utcOffset = () => {
  return -date.getTimezoneOffset();
};

export const getTimeZoneShortName = () => {
  // You can pass undefined instead of en-us to default to the browser's current locale
  return date.toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
};
